import React from 'react';
import { SideMenuItem }  from '../SidemenuItems';
import { Div } from '../../../../components/grid';

export default ({
  activeSidemenu,
}) => (
  <Div>
    <SideMenuItem to="/kulsyre" title="Kulsyre" active={activeSidemenu === 'Kulsyre'} main />
    <SideMenuItem to="/kulsyre/kulsyre-til-fadoel" title="Kulsyre til Fadøl" active={activeSidemenu === 'KulsyreFadoel'} />
    <SideMenuItem to="/kulsyre/sodastream" title="Kulsyre til SodaStream" active={activeSidemenu === 'KulsyreSodastream'} />
    <SideMenuItem to="/kulsyre/danskvandsanlaeg" title="Kulsyre til Danskvandsanlæg" active={activeSidemenu === 'KulsyreQuooker'} />
    <SideMenuItem to="/kulsyre/opfyldning-af-kulsyreflasker" title="Opfyldning af kulsyreflasker" active={activeSidemenu === 'OpfyldningKulsyre'} />
    <SideMenuItem to="/kulsyre/kulsyrebatterier" title="Kulsyrebatterier" active={activeSidemenu === 'KulsyreBatterier'} />
    <SideMenuItem to="/kulsyre/co2-akvarie" title="Kulsyre til Akvarier" active={activeSidemenu === 'KulsyreAkvarier'} />
    <SideMenuItem to="/kulsyre/drikkevandskoeler" title="Kulsyre til Drikkevandskølere" active={activeSidemenu === 'KulsyreDrikkevandsKoeler'} />
    <SideMenuItem to="/kulsyre/co2-svejsning" title="Kulsyre til CO2 Svejsning" active={activeSidemenu === 'KulsyreCO2Svejsning'} />
  </Div>
);
